/**
 * created by wang lei
 删除列 页面
 *
 */
import React, {Component} from 'react';
import deleteColumns from './deleteColumns.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class DeleteColumnsTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            deleteColumns:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let deleteColumns = this.props.editor.queryCommandState('deleteTable')
        this.setState({deleteColumns: deleteColumns === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let deleteColumns = this.props.editor.queryCommandState('deleteTable')
        this.setState({deleteColumns: deleteColumns === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.deleteColumns ? "1":"0.3"}}>
                <img className={"editor-delete-columns-tool-btn"} src={deleteColumns} onClick={()=>this.props.editor.execCommand("deletecol")}/>
                {this.state.deleteColumns ? <style>{`
                    .editor-delete-columns-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-delete-columns-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-delete-columns-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style> : <style>{`
                    .editor-delete-columns-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-delete-columns-tool-btn:hover{
                        border: 1px solid transparent
                    }
                    .editor-delete-columns-tool-btn:active{
                        border: 1px solid transparent
                    }
                `}</style>}

            </span>
        )
    }

}